import { Link } from '@inertiajs/react'

export interface BreadcrumbItem {
  title: string
  slug: string
  path: string
}

interface BreadcrumbsProps {
  workspaceName: string
  workspaceSlug: string
  crumbs: BreadcrumbItem[]
}

export default function Breadcrumbs({ workspaceName, workspaceSlug, crumbs }: BreadcrumbsProps) {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-sm text-gray-500">
      <Link href={`/${workspaceSlug}`} className="hover:text-gray-700">
        {workspaceName}
      </Link>
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1
        return (
          <span key={crumb.slug} className="flex items-center gap-2">
            <span className="text-gray-300">/</span>
            {isLast ? (
              <span className="font-medium text-gray-900">{crumb.title}</span>
            ) : (
              <Link
                href={`/${workspaceSlug}/${crumb.path}`}
                className="hover:text-gray-700"
              >
                {crumb.title}
              </Link>
            )}
          </span>
        )
      })}
    </nav>
  )
}
